import { IconSvgElement } from "@hugeicons/react";
import { useNeedsLockboxCount } from "shared/hooks/use-needs-lockbox-count";
import { formatNavBadgeCount } from "../use-nav-item-counts";
import { NavLink } from "./NavLink";

export const UnitsNavLink = ({
  name,
  to,
  Icon
}: {
  name: string;
  to: string;
  Icon: IconSvgElement;
}) => {
  const count = useNeedsLockboxCount();

  return (
    <NavLink
      to={to}
      HugeIcon={Icon}
      indicator={count > 0 ? formatNavBadgeCount(count) : undefined}
    >
      {name}
    </NavLink>
  );
};
